export const PUBLICATION_TYPE_ASSOCIATION = 'association';
export const PUBLICATION_TYPE_MAGAZINE = 'magazine';
export const PUBLICATION_TYPE_NEWSPAPER = 'newspaper';
export const PUBLICATION_TYPE_ONLINE = 'online';
export const PUBLICATION_TYPE_OTHER = 'other';

export const PUBLICATION_TYPES = [
    PUBLICATION_TYPE_ASSOCIATION,
    PUBLICATION_TYPE_MAGAZINE,
    PUBLICATION_TYPE_NEWSPAPER,
    PUBLICATION_TYPE_ONLINE,
    PUBLICATION_TYPE_OTHER
];
